import { Button } from "takeat-design-system-ui-kit";
import styled from "styled-components";

export const WappAlertDrawerContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 350px;

  > header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    > p {
      color: #222;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0;
    }

    > div {
      cursor: pointer;
    }
  }

  > span {
    color: var(--Takeat-Colors-Neutrals-Black-01, #222);
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.1px;
  }
`

export const WappAlertDrawerElement = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  border-radius: 12px;
  border: 1px solid #EDEDED;
  background: #F6F6F6;
  justify-content: space-between;

  * {
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    line-height: 20px;
    letter-spacing: 0.1px;
  }
  
  div {
    display: flex;
    flex-direction: column;
    gap: 4px;

    p {
      color: #222;
      font-weight: 700;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
    }
  
    span {
      color: #545454;
      font-weight: 700;
    }
  
    section {
      color: #545454;
      font-weight: 600;
    }
  }

  > footer {
    display: flex;
    flex-direction: row;
    gap: 11px;

    > button:nth-child(1) {
      padding: 0 12px 0 8px;
    }

    > button:nth-child(2) {
      padding: 0 16px;
    }
  }
`

export const WppAlertButton = styled(Button)`

`

export const WppSolvedCard = styled.section`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  border: 1px solid var(--Takeat-Colors-Green-Variations-05, #0F635A);
  background: var(--Takeat-Colors-Green-Variations-00, #EBFAF8);

  color: var(--Takeat-Colors-Green-Variations-05, #0F635A);
  text-align: center;

  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  line-height: 16px;
  letter-spacing: 0.5px;
`

export const WppAlertDrawerClearAndCounter = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  > span {
    width: fit-content;
    align-items: center;
    align-self: center;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.1px;
  }

  > button {
    padding: 0 8px;
  }
`

export const DeliveryRetiradaCard = styled.div`
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #7A7A7A;
  color: var(--Takeat-Colors-Neutrals-Grey-05, #F6F6F6);

  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
`